<template>
  <div id="row-style" class="container-fluid col-12 pb-2">
    <div class="row justify-content-center">
      <div class="col-11 col-lg-10 col-xl-9">
        <div class="row justify-content-center">
          <div class="text-left col-6 align-self-center mt-4">
            <h1>{{ $t('discovery-title') }}</h1>
            {{ $t('discovery-content-1') }}

            <ul class="d-none d-md-inline-block mt-2">
              <li>{{ $t('discovery-content-2') }}</li>
              <li>{{ $t('discovery-content-3') }}</li>
              <li>{{ $t('discovery-content-4') }}</li>
            </ul>
          </div>
          <div class="col-6 align-self-center mt-4">
            <img src="../assets/discover.png" class="img-fluid" alt="discover">
          </div>

          <div class="text-left col-12 align-self-center">
            <ul class="d-inline-block d-md-none mt-2">
              <li>{{ $t('discovery-content-2') }}</li>
              <li>{{ $t('discovery-content-3') }}</li>
              <li>{{ $t('discovery-content-4') }}</li>
            </ul>
          </div>

        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <button v-if="(!isWelcomeDiscoveryContent) && (signedUser === undefined)" @click="$router.push('registerOrLogin')" type="button" class="btn btn-primary mb-2">Embark for a journey to DAGOBAH</button>
      <button v-if="(!isWelcomeDiscoveryContent) && (signedUser !== undefined)" @click="$router.push('projects')" type="button" class="btn btn-primary mb-2">Embark for a journey to DAGOBAH</button>
      <MailtoLink v-if="isWelcomeDiscoveryContent" predefinedEmailContent="GET_A_DEMO">
        <button type="button" class="btn btn-primary welcomeButton rounded mb-2"><span class="mr-4 ml-4">Get a demo</span></button>
      </MailtoLink>
    </div>
  </div>
</template>

<script>
import MailtoLink from "./global/MailtoLink.vue";

export default {
  name: 'DiscoveryContent',
  props: ["isWelcomeDiscoveryContent"],
  components: {
    MailtoLink,
  },
  computed: {
    signedUser: function() {
      return (this.$store.state.identityIdentified !== undefined) ? this.$store.state.identityIdentified.email : undefined;
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#row-style {
  background-color: #faf89f;
}

.btn-primary.welcomeButton {
  color: white;
  font-size: 1.3rem;
}

</style>
